import { ContactPreference } from "./contact-preference.model";

export class PhotoEstimateAssignment {
    alternatePhone?: string;
    alternateEmail?: string;
    replaceExistingAssignment?: boolean;
    contactPreference?: ContactPreference;
}